<div class="widget">
  <!-- init loader -->
  <div *ngIf="isLoading" class="flex flex-col items-center my-5">
    <div class="spinner mb-3 mx-auto"></div>
    <p>{{ 'widget.loading' | translate }}</p>
  </div>

  <!-- geolocation error message -->
  <div
    *ngIf="!isLoading && showGeolocationErrorMessage"
    class="flex justify-center m-5"
  >
    <p>{{ 'widget.geolocation-unauthorized' | translate }}</p>
  </div>

  <div *ngIf="!isLoading && !showGeolocationErrorMessage">
    <!-- slider controls -->
    <div class="swiper-controls flex flew-row">
      <app-widget-lang-selector
        *ngIf="langs"
        class="ml-2"
        [langs]="langs"
      ></app-widget-lang-selector>

      <div class="swiper-pagination flex-grow"></div>
    </div>

    <!-- activity slider -->
    <div class="flex flex-row">
      <div class="hidden sm:flex flex-1 items-center justify-center">
        <div class="swiper-button-prev">
          <button
            app-vtmn-play-button
            type="button"
            [shape]="vtmnPlayButtonShape.SQUARED"
            [size]="vtmnPlayButtonSize.SMALL"
            [attr.aria-label]="'a11y.slider.button.previous' | translate"
          ></button>
        </div>
      </div>

      <swiper
        [config]="config"
        [virtual]="true"
        [ngClass]="{ '!w-full': activityCollection?.length < 4 }"
      >
        <ng-template swiperSlide *ngFor="let activity of activityCollection"
          ><a
            [href]="activityUrl(activity)"
            target="_blank"
            [rel]="'noopener noreferrer'"
            [attr.aria-label]="activity.name"
          >
            <app-attendee-activity-card
              [activity]="activity"
            ></app-attendee-activity-card> </a
        ></ng-template>
      </swiper>

      <div class="hidden sm:flex flex-1 items-center justify-center">
        <div class="swiper-button-next">
          <button
            app-vtmn-play-button
            type="button"
            class="category-collection__navigation__button"
            [shape]="vtmnPlayButtonShape.SQUARED"
            [size]="vtmnPlayButtonSize.SMALL"
            [attr.aria-label]="'a11y.slider.button.next' | translate"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
